import * as deliveryMen from './list'

import { DeliveryMan } from 'app/types/users/deliveryMan'

export const allDeliveryMen: DeliveryMan[] = Object.values(deliveryMen).sort(
    (previous, current) =>
        previous.last_name.localeCompare(current.last_name) ||
        previous.first_name.localeCompare(current.first_name),
)
